---
nb:
  general:
    24h_stats: 24t stats
    5min_stats: 5min stats
    7d_stats: 7dager stats
    access_level:
      admin: Administrator
      developer: Utvikler
      editor: Editor
      landowner: Grunneier
      portfolio: Portefølje
    access_rights: Tilgangsrett
    action_might_be_irreversible: Denne handlingen kan være uopprettelig.
    activate: Aktiver
    active: Aktiv
    activity: Aktivitet
    actual: Faktisk
    add: Legg til
    add_as_custom_chart: Legg til som tilpasset diagram?
    add_attachment: Legg til vedlegg
    add_image: Legg til bilde
    add_new: Legg til ny
    add_power-plant-supplier_connection: Legg til kraftverkleverandørforbindelse
    add_supplier_role: Legg til leverandørrolle
    add_user: Legg til bruker
    admin: Admin
    all: Alle
    all_caps: ALL
    and: og
    apply: Bruk
    are_you_sure: Er du sikker?
    area: Område
    area_price: Områdepris
    asset_class: Klasse
    avail_analysis: Tilgjengelighetsanalyse
    availability_calculation: Tilgjengelighetsberegning
    average_last_24_hours: 24T snitt
    avg_price: Gjennomsnittspris
    back: Tilbake
    back_to_list: Tilbake til liste
    basic: Grunnleggende
    basic_details: Grunnleggende detaljer
    bilateral: Bilateral
    budget: Budsjett
    budget_lowercase: budsjett
    budgets: Budsjett
    bulk_edit_hint: Lim inn tall direkte fra Excel; bruk tabulator-separerte verdier for volum og deretter inntekt.
    bulk_update: Masseoppdatering
    cancel: Avbryt
    cant_delete_company: Kan ikke slette selskap
    capacity: Kapasitet
    card_description: Kortbeskrivelse
    category: Kategorier
    chart_title: Diagramtittel
    click_to_load_more: Klikk for å laste mer
    climate_futures_inflow: Climate Futures tilsig
    close: Lukk
    commercial_details: Komersielle detaljer
    community: Community
    companies: Selskaper
    company: Selskap
    company_access: Bedriftstilgang
    confirm: Bekreft
    confirmed: Bekreftet
    connections: Koblinger
    contact_kaiasolutions: Bytt til en individuell portefølje med tilgang, eller kontakt Kaia Solutions hvis du ønsker å aktivere denne funksjonen.
    contract_deleted: Kontrakt slettet
    contract_details: Kontraktdetaljer
    contract_type: Kontraktstype
    contracts_admin: Kontrakter Admin
    copied: Kopiert!
    copy: Kopier
    country: Land
    county: Fylke
    create: Opprett
    created: Opprettet
    custom_lower_limit: Tilpasset nedre grense
    custom_unit: Tilpasset enhet
    custom_upper_limit: Tilpasset øvre grense
    daily: Daglig
    data_source: Data kilde
    data_source_configuration: Datakilde konfigurasjon
    date: Dato
    date_from: Fra
    date_scope: Tidsrom
    date_to: Til
    days: dager
    de: Tysk
    deactivate: Deaktiver
    delete: Slett
    delete_all: Slett alle
    delete_failed: Sletting mislyktes
    deleted: Slettet
    description: Beskrivelse
    details: Detaljer
    deviation: Avvik
    download: Last ned
    edit: Rediger
    edit_supplier_role: Rediger leverandørrolle
    edit_user: Rediger bruker
    elcert: Elsert
    elcert/GoO: Elsert / GoO
    elcert_full: Elsertifikater
    email: E-post
    en: Engelsk
    end_date: Sluttdato
    energy: Energi
    error: Det oppstod en feil. Vennligst prøv igjen.
    error_reset_password: Feil ved tilbakestilling av passord
    est_resource: Est. ressurs
    event: Hendelse
    export_access: Eksporttilgang
    feature_configuration: Funksjonskonfigurasjon
    filter: filter
    filter_by_company: Filtrer etter selskap
    filter_data: Filtrer data
    first_name: Fornavn
    flip_sign: Snu fortegn
    forecast: Prognostisert
    forecast_lowercase: prognostisert
    fr: Fransk
    general: Generelt
    go_expiry_date: Utløpsdato for GO
    go_full: Opprinnelsesgarantier
    gwh: GWh
    half_yearly: Halvårlig
    hide: Skjul
    hourly: Hver time
    hours: Timer
    hydro: Hydro
    image: Bilde
    inactive: Inaktiv
    inflow: Tilsig
    intake: Inntak
    ip: IP
    language: Språk
    last_activity: Siste aktivitet
    last_name: Etternavn
    limit: Grense
    links: Lenker
    lock_account: Lås kontoen
    logged_in_successfully: Logget inn
    login: Logg inn
    login_failed: Innlogging feilet
    login_failures: Innloggingsfeil
    logo: Logo
    metering_point: Målepunkt
    month: Måned
    monthly: Månedlig
    mw: MW
    name: Navn
    nb: Norsk
    new: ny
    'no': Nei
    no_image_available: Ingen bilde tilgjengelig
    none: Ingen
    not_enabled: er ikke aktivert for valgt portefølje eller alle porteføljer i det globale utvalget.
    not_specified: Ikke spesifisert
    now: nå
    number_of_power_plants: Antall kraftverk
    nve_metadata: NVE metadata
    ny_budget: NY budsjett
    offset: Forskyvning
    operational_state: Driftstilstand
    or: eller
    org_no: Org. nr
    other_info: Annet info
    overview: Oversikt
    pareto: Pareto
    password: Passord
    path: Sti
    power_plant: Kraftverk
    power_plant_lowercase: kraftverk
    power_plant_names: Kraftverksnavn
    power_plants: Kraftverk
    power_plants_lowercase: kraftverk
    power_prices: Kraftpriser
    power_production: Kraftproduksjon
    power_sales: Kraftsalg
    precipitation: Nedbør
    price: Pris
    price_area: Prisområde
    production: Produksjon
    production_budget: Produksjonsbudsjett
    production_forecast: Prognostisert produksjon
    profile: Profil
    profile_lowercase: profil
    project: Prosjekt
    quarterly: Kvartalsvis
    radiation: Stråling
    remove: Fjern
    remove_attachment: Fjern vedlegg
    remove_image: Fjern bilde
    report_generated: Rapport generert
    requests: Forespørsler
    reset: Nullstill
    reset_password: Tilbakestill passord
    resolution: Oppløsning
    result: Resultat
    result_lowercase: resultat
    retry: Prøv igjen
    revenue: Omsetning
    revenue_budget: Omsetningsbudsjett
    rotate: Roter
    runoff: Avrenning
    save: Lagre
    save_successful: Lagring vellykket
    saved: Lagret
    scale_factor: Skaleringsfaktor
    search: Søk
    search_by: Søk etter navn, e-post eller tilgangsnivå
    search_by_name: Søk etter navn
    search_companies: Søk bedrifter
    search_counties: Søk fylker
    search_powerplants: Søk kraftverk
    seconds: Sekunder
    select: Velg
    select_asset_type: Velg anleggstype
    select_columns: Velg kolonner
    selection: Valg
    send: Send
    sensors: Nest sensorer
    show: Vis
    show_edit: Se/Endre
    show_less: Vis mindre
    show_more: Vis %{count} til
    show_subsidiaries: Vis datterselskaper
    slowest: Tregest
    snow: Snø
    solar: Sol
    solar_backend_configuration: Sol backend-konfigurasjon
    sort_by: Sorter etter
    spot_price: Spotpris
    start_date: Startdato
    statistics: Statistikk
    status: Status
    summary: Oppsummering
    supplier_contact_email: Leverandørkontakt e-post
    supplier_contact_phone: Leverandørkontakt telefon
    supplier_name: Leverandørnavn
    temperature: Temperatur
    tertiary: Tertiær
    timestamp: Tidspunkt
    title: Tittel
    to: til
    today: I dag
    token: Token
    top: Topp
    total: Totalt
    total_production: Total produksjon
    trend_last_24_hours: 24T trend
    treshold_mw: Terskel MW
    unexpected_error: Uventet feil
    unknown: Ukjent
    unknown_error: Noe gikk galt
    unlock_account: Låse opp kontoen
    unsaved_changes: Du har ulagrede endringer.
    update: Oppdater
    updated: Oppdatert
    user_access_level: Tilgangsnivå
    valid_contract: Gyldig kontrakt
    validations:
      non_negative: Ikke negativ
      required: Nødvendig
    view_details: Vis detaljer
    volume: Volum
    volume_percent: Volumprosent
    weekly: Ukentlig
    welcome: Velkommen
    wind: Vind
    wind_backend_configuration: Vind backend-konfigurasjon
    wind_speed: Vindhastighet
    wrong_email_or_password: Feil e-postadresse eller passord
    year: År
    yearly: Årlig
    'yes': Ja
